import { useCallback } from "react";

const useElementDimensions = ({ elementRef = null } = {}) => {
	const getBoundingClientRect = useCallback(() => {
		const element =
			typeof elementRef === "object" ? elementRef?.current : elementRef;
		if (!element) return {};
		return element?.getBoundingClientRect() || {};
	}, [elementRef]);

	const getHeight = useCallback(() => {
		const { height } = getBoundingClientRect();
		return height || null;
	}, [getBoundingClientRect]);

	const getWidth = useCallback(() => {
		const { width } = getBoundingClientRect();
		return width || null;
	}, [getBoundingClientRect]);

	return { getBoundingClientRect, getHeight, getWidth };
};

export default useElementDimensions;
